import { backgroundTransitionOnClick, DatePicker, Input, pointer, Select } from '@byecode/ui'
import styled from 'styled-components'

import { MultiSelect } from '../MultiSelect'

export const Box = styled.div`
    display: flex;
    flex-flow: row nowrap;
`

export const ParamsSelect = styled(Select)`
    width: 100%;
    height: 32px;
`

// export const ParamsCascadeSelect = styled(CascadeSelect) <{ focusOutLine?: string }>`
//     width: 100%;
//     height: 32px;
//     background-color: #fff;
//     border-radius: 6px;
//     border: 1px solid var(--color-gray-200);

//     &:hover {
//         border-color: ${({ focusOutLine }) => focusOutLine ?? 'var(--color-main)'};
//     }
// `

export const ParamsMultiSelect = styled(MultiSelect)<{ focusOutLine?: string }>`
    width: 100%;
    min-width: 120px;
    height: 32px;
    background-color: #fff;
    border-radius: 6px;
    background-color: var(--color-gray-100);
`

export const ParamsDatePicker = styled(DatePicker)<{ theme?: string }>`
    height: 32px;
    background-color: #fff;
    border-radius: 6px;
    border: 1px solid #dfdfdd;
    padding-left: 0;

    &:hover {
        border-color: ${({ theme }) => theme ?? 'var(--color-main)'};
    }
`

export const ParamsInput = styled(Input)<{ width?: string }>`
    width: ${({ width }) => width || 'auto'};
    height: 32px;
`

export const MorePopoverWrapper = styled.div`
    display: flex;
    width: 30px;
    height: 30px;
    line-height: 31px;
    border-radius: 4px;
    justify-content: center;

    ${pointer}
`

export const IconWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    color: var(--color-gray-400);

    &:hover {
        color: var(--color-black);
    }
`

export const List = styled.div`
    width: 160px;
`

export const Item = styled.div<{ disabled?: boolean }>`
    padding: 6px 16px;
    font-size: var(--font-size-normal);
    cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
    ${backgroundTransitionOnClick}
`

export const Describe = styled.div`
    color: var(--color-gray-400);
    font-size: var(--font-size-sm);
    padding-left: 24px;
`

export const SelectItemWrapper = styled.div``
